import { render, staticRenderFns } from "./ImagenesSatelitales.vue?vue&type=template&id=778b2bca&scoped=true"
import script from "./ImagenesSatelitales.vue?vue&type=script&lang=ts"
export * from "./ImagenesSatelitales.vue?vue&type=script&lang=ts"
import style0 from "./ImagenesSatelitales.vue?vue&type=style&index=0&id=778b2bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b2bca",
  null
  
)

export default component.exports